import { MapPin } from "lucide-react";

export const SiteMap = ({ address, height = 280, testId = "site-map" }) => {
  if (!address?.trim()) return null;
  return (
    <div className="rounded-lg overflow-hidden border border-slate-800 print-avoid" data-testid={testId}>
      <iframe title="Site map" src={`https://maps.google.com/maps?q=${encodeURIComponent(address)}&z=16&output=embed`}
        width="100%" height={height} style={{ border: 0, filter: "invert(0.9) hue-rotate(180deg) saturate(0.6)" }} loading="lazy" />
      <p className="flex items-center gap-2 px-4 py-2 text-xs text-slate-400 bg-slate-950/60"><MapPin className="h-3.5 w-3.5 text-emerald-400" />{address}</p>
    </div>
  );
};
